import { BEAM_REQUEST, CREATE_BEAM, GET_BEAMS, UPDATE_BEAM, DELETE_BEAM, BEAM_REQUEST_FAILURE, GET_BEAMS_WITH_DETAIL } from '../types';

const initialState = {
  beams: [],
  beamsWithDetail: [],
  loading: false,
  error: null,
};

const beamReducer = (state = initialState, action) => {
  switch (action.type) {
    case BEAM_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BEAMS: {
      return {
        ...state,
        beams: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_BEAMS_WITH_DETAIL: {
      return {
        ...state,
        beamsWithDetail: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_BEAM:
      return {
        ...state,
        beams: [action.payload, ...state.beams],
        loading: false,
        error: null
      };
    case UPDATE_BEAM:
      const beamsData = state.beams.slice(0);
      const uIndex = beamsData.findIndex((data) => data.id === action.payload.id);
      beamsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        beams: [ ...beamsData ],
        loading: false,
        error: null
      };
    case DELETE_BEAM:
      const beams = state.beams?.slice(0);
      const index = beams.findIndex((data) => data.id === action.id);
      if (index > -1) {
        beams.splice(index, 1);
      }
      return {
        ...state,
        beams: [...beams],
        loading: false,
        error: null
      }
    case BEAM_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default beamReducer;
